import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { X } from 'lucide-react';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

export default function EmbeddedCheckoutModal({ clientSecret, onClose }) {
  const options = useMemo(() => ({ clientSecret }), [clientSecret]);

  if (!publishableKey) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
        <div className="max-w-md rounded-lg bg-white p-6 shadow-xl">
          <p className="text-sm text-red-600">
            Configuração do Stripe ausente: defina <code>REACT_APP_STRIPE_PUBLISHABLE_KEY</code>.
          </p>
          <button
            type="button"
            onClick={onClose}
            className="mt-4 rounded bg-gray-800 px-4 py-2 text-sm text-white"
          >
            Fechar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-white shadow-xl">
        <button
          type="button"
          onClick={onClose}
          aria-label="Fechar checkout"
          className="absolute right-3 top-3 z-10 rounded-full bg-white/90 p-2 text-gray-600 shadow hover:bg-white hover:text-gray-900"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="overflow-y-auto">
          {clientSecret && (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
}
